import { render, staticRenderFns } from "./liveArea.vue?vue&type=template&id=8518bfee&scoped=true&"
import script from "./liveArea.vue?vue&type=script&lang=js&"
export * from "./liveArea.vue?vue&type=script&lang=js&"
import style0 from "./liveArea.vue?vue&type=style&index=0&id=8518bfee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8518bfee",
  null
  
)

export default component.exports